export interface HttpHeaders {
  [name: string]: string;
}
